import { DEFAULT_TOAST_LIFE } from "../../../../common/EzToast";
import { rateAdminAdvanceRateServices } from "../../../../services";
import { goBack } from "../../../../utils/gotoback";
import {
  FETCH_RATEADMIN_ADVANCERATE_INIT,
  FETCH_RATEADMIN_ADVANCERATE_LIST,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  INIT_CREATE_RATEADMIN_ADVANCERATE_SCREEN,
  CREATE_RATEADMIN_ADVANCERATE,
  EDIT_RATEADMIN_ADVANCERATE,
  TOAST,
  FETCH_RATEADMIN_ADVANCERATE_DETAIL,
  EXPORT_RATEADMIN_ADVANCERATE,
  RATEADMIN_ADVANCERATEDD,
  RATEADMIN_ADVANCERATE_DELETE,
  RATEADMIN_ADVANCERATE_SAVE_TABLE_STATE,
  SEARCH_ADVANCE_RATE,
  UPDATE_ADVANCE_RATE,
} from "../../../types/RateAdmin/rateadminadvancerate.type";

export const initializeRateAdminAdvanceRateScreen = () => ({ type: FETCH_RATEADMIN_ADVANCERATE_INIT });

export const rateadminAdvanceRateFetchStart = (payload) => ({
  type: FETCH_RATEADMIN_ADVANCERATE_LIST.START,
  payload,
});

export const rateadminAdvanceRateFetchSuccess = (payload) => ({
  type: FETCH_RATEADMIN_ADVANCERATE_LIST.SUCCESS,
  payload,
});

export const rateadminAdvanceRateFetchError = (payload) => ({
  type: FETCH_RATEADMIN_ADVANCERATE_LIST.ERROR,
  payload,
});

export const fetchRateAdminAdvanceRate = (payload) => {
  return (dispatch) => {
    dispatch(rateadminAdvanceRateFetchStart(payload));
    rateAdminAdvanceRateServices.fetchRateAdminAdvanceRate(payload).then((data) => {
      if (!data.isError) {
        dispatch(rateadminAdvanceRateFetchSuccess(data));
      } else {
        dispatch(rateadminAdvanceRateFetchError(data));
      }
    });
  };
};

// Dropdown Actions
export const rateadminAdvanceRateDDFetchStart = (payload) => ({
  type: RATEADMIN_ADVANCERATEDD.START,
  payload,
});

export const rateadminAdvanceRateDDFetchSuccess = (payload) => ({
  type: RATEADMIN_ADVANCERATEDD.SUCCESS,
  payload,
});

export const rateadminAdvanceRateDDFetchError = (payload) => ({
  type: RATEADMIN_ADVANCERATEDD.ERROR,
  payload,
});

export const fetchRateAdminAdvanceRateDD = (payload) => {
  return (dispatch) => {
    dispatch(rateadminAdvanceRateDDFetchStart(payload));
    rateAdminAdvanceRateServices.fetchRateAdminAdvanceRateDropdown(payload).then((data) => {
      if (!data.isError) {
        dispatch(rateadminAdvanceRateDDFetchSuccess(data));
      } else {
        dispatch(rateadminAdvanceRateDDFetchError(data));
      }
    });
  };
};

export const setDeleteConfirmationPopupVisibility = (payload) => ({
  type: SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  payload,
});

export const rateadminAdvanceRateDetailFetchStart = (payload) => ({
  type: FETCH_RATEADMIN_ADVANCERATE_DETAIL.START,
  payload,
});

export const rateadminAdvanceRateDetailFetchSuccess = (payload) => ({
  type: FETCH_RATEADMIN_ADVANCERATE_DETAIL.SUCCESS,
  payload,
});

export const rateadminAdvanceRateDetailFetchError = (payload) => ({
  type: FETCH_RATEADMIN_ADVANCERATE_DETAIL.ERROR,
  payload,
});

export const fetchRateAdminAdvanceRateById = (payload) => {
  return (dispatch) => {
    dispatch(rateadminAdvanceRateDetailFetchStart(payload));
    rateAdminAdvanceRateServices
      .fetchRateAdminAdvanceRateById(payload)
      .then((data) => {
        if (!data.isError) {
          dispatch(rateadminAdvanceRateDetailFetchSuccess(data));
        } else {
          dispatch(rateadminAdvanceRateDetailFetchError(data));
        }
      });
  };
};

export const initCreateRateAdminAdvanceRateScreen = (payload) => ({
  type: INIT_CREATE_RATEADMIN_ADVANCERATE_SCREEN,
  payload,
});

// Create Actions
export const createRateAdminAdvanceRateStart = (payload) => ({
  type: CREATE_RATEADMIN_ADVANCERATE.START,
  payload,
});

export const createRateAdminAdvanceRateSuccess = (payload) => ({
  type: CREATE_RATEADMIN_ADVANCERATE.SUCCESS,
  payload,
});

export const createRateAdminAdvanceRateError = (payload) => ({
  type: CREATE_RATEADMIN_ADVANCERATE.ERROR,
  payload,
});

export const createRateAdminAdvanceRate = (payload) => {
  return (dispatch) => {
    dispatch(createRateAdminAdvanceRateStart(payload));
    rateAdminAdvanceRateServices.createRateAdminAdvanceRate(payload).then((data) => {
      if (!data.isError) {
        dispatch(createRateAdminAdvanceRateSuccess(data));
      } else {
        dispatch(createRateAdminAdvanceRateError(data));
      }
    });
  };
};

// Edit Actions
export const editRateAdminAdvanceRateStart = (payload) => ({
  type: EDIT_RATEADMIN_ADVANCERATE.START,
  payload,
});

export const editRateAdminAdvanceRateSuccess = (payload) => ({
  type: EDIT_RATEADMIN_ADVANCERATE.SUCCESS,
  payload,
});

export const editRateAdminAdvanceRateError = (payload) => ({
  type: EDIT_RATEADMIN_ADVANCERATE.ERROR,
  payload,
});

export const editRateAdminAdvanceRate = (payload) => {
  return (dispatch) => {
    dispatch(editRateAdminAdvanceRateStart(payload));
    rateAdminAdvanceRateServices.editRateAdminAdvanceRate(payload).then((data) => {
      if (!data.isError) {
        dispatch(editRateAdminAdvanceRateSuccess(data));
        goBack();
      } else {
        dispatch(editRateAdminAdvanceRateError(data));
      }
    });
  };
};

// Delete Actions
export const deleteRateAdminAdvanceRateStart = (payload) => ({
  type: RATEADMIN_ADVANCERATE_DELETE.START,
  payload,
});

export const deleteRateAdminAdvanceRateSuccess = (payload) => ({
  type: RATEADMIN_ADVANCERATE_DELETE.SUCCESS,
  payload,
});

export const deleteRateAdminAdvanceRateError = (payload) => ({
  type: RATEADMIN_ADVANCERATE_DELETE.ERROR,
  payload,
});

export const deleteRateAdminAdvanceRate = (payload) => {
  return (dispatch) => {
    dispatch(deleteRateAdminAdvanceRateStart(payload));
    rateAdminAdvanceRateServices.deleteRateAdminAdvanceRate(payload).then((data) => {
      if (!data.isError) {
        dispatch(deleteRateAdminAdvanceRateSuccess(data));
        dispatch(setDeleteConfirmationPopupVisibility(false));
      } else {
        dispatch(deleteRateAdminAdvanceRateError(data));
      }
    });
  };
};

// Export Actions
export const exportRateAdminAdvanceRateStart = (payload) => ({
  type: EXPORT_RATEADMIN_ADVANCERATE.START,
  payload,
});

export const exportRateAdminAdvanceRateSuccess = (payload) => ({
  type: EXPORT_RATEADMIN_ADVANCERATE.SUCCESS,
  payload,
});

export const exportRateAdminAdvanceRateError = (payload) => ({
  type: EXPORT_RATEADMIN_ADVANCERATE.ERROR,
  payload,
});

export const exportRateAdminAdvanceRate = (payload) => {
  return (dispatch) => {
    dispatch(exportRateAdminAdvanceRateStart(payload));
    rateAdminAdvanceRateServices.exportRateAdminAdvanceRate(payload).then((data) => {
      if (!data.isError) {
        dispatch(exportRateAdminAdvanceRateSuccess(data));
      } else {
        dispatch(exportRateAdminAdvanceRateError(data));
      }
    });
  };
};

// Save Table State
export const saveAdvanceRateTableState = (payload) => ({
  type: RATEADMIN_ADVANCERATE_SAVE_TABLE_STATE,
  payload,
});

// Search Advance Rate Actions
export const searchAdvanceRateStart = (payload) => ({
  type: SEARCH_ADVANCE_RATE.START,
  payload,
});

export const searchAdvanceRateSuccess = (payload) => ({
  type: SEARCH_ADVANCE_RATE.SUCCESS,
  payload,
});

export const searchAdvanceRateError = (payload) => ({
  type: SEARCH_ADVANCE_RATE.ERROR,
  payload,
});

export const searchAdvanceRate = (payload) => {
  return (dispatch) => {
    dispatch(searchAdvanceRateStart(payload));
    rateAdminAdvanceRateServices.searchAdvanceRate(payload).then((data) => {
      if (!data.isError) {
        dispatch(searchAdvanceRateSuccess(data));
      } else {
        dispatch(searchAdvanceRateError(data));
      }
    });
  };
};

// Update Advance Rate Actions
export const updateAdvanceRateStart = (payload) => ({
  type: UPDATE_ADVANCE_RATE.START,
  payload,
});

export const updateAdvanceRateSuccess = (payload) => ({
  type: UPDATE_ADVANCE_RATE.SUCCESS,
  payload,
});

export const updateAdvanceRateError = (payload) => ({
  type: UPDATE_ADVANCE_RATE.ERROR,
  payload,
});

export const updateAdvanceRate = (payload) => {
  return (dispatch) => {
    dispatch(updateAdvanceRateStart(payload));
    rateAdminAdvanceRateServices.updateAdvanceRate(payload).then((data) => {
      if (!data.isError) {
        dispatch(updateAdvanceRateSuccess(data));
      } else {
        dispatch(updateAdvanceRateError(data));
      }
    });
  };
};
